import ReactGA from 'react-ga4';

export const ADS_CONVERSION_ID = 'AW-11342294943';

// Conversion labels from Google Ads UI (Goals → Conversions → each action).
// tourInquirySubmit confirmed from "Submit lead form" snippet 2026-05-10.
export const ADS_LABELS = {
  tourInquirySubmit: 'wB7xCKiA2KkcEJ_ftqAq',
  whatsappClick: null,   // TODO: extract from WhatsApp click conversion action
  phoneClick: null,      // TODO: extract from Phone call leads conversion action
};

/**
 * Fire a Google Ads conversion event. Pass a label key from ADS_LABELS once
 * available; until then it fires unlabeled and the Ads tag still records the
 * hit for remarketing audiences.
 */
export const trackAdsConversion = (labelKey) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const label = labelKey ? ADS_LABELS[labelKey] : null;
  window.gtag('event', 'conversion', {
    send_to: label ? `${ADS_CONVERSION_ID}/${label}` : ADS_CONVERSION_ID,
  });
};

/**
 * Track a custom GA4 event
 * @param {string} category - Event category (e.g., 'Contact', 'Navigation', 'Booking')
 * @param {string} action - Event action (e.g., 'form_submit', 'click_whatsapp')
 * @param {string} [label] - Optional label (e.g., tour name)
 */
export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

/**
 * Track outbound link clicks
 */
export const trackOutboundLink = (url, label) => {
  ReactGA.event({
    category: 'Outbound',
    action: 'click',
    label: label || url,
  });
};

/**
 * Track form interactions. Optional `meta` object adds GA4 event params
 * (e.g. { contact_variant: 'tight' } for A/B testing). Built so the existing
 * 1-arg call sites keep working unchanged.
 */
const fireGa = (category, action, label, meta) => {
  ReactGA.event({ category, action, label });
  if (meta && typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, { event_category: category, event_label: label, ...meta });
  }
};

export const trackFormStart = (formName, meta) => fireGa('Form', 'form_start', formName, meta);
export const trackFormSubmit = (formName, meta) => fireGa('Form', 'form_submit', formName, meta);

/**
 * Track conversion on thank you page. Fires both the GA4 lead event and the
 * Google Ads conversion ping so a successful inquiry shows up in both.
 * `meta` propagates to GA4 (e.g. variant tag).
 */
export const trackConversion = (meta) => {
  fireGa('Conversion', 'generate_lead', 'contact_form', meta);
  trackAdsConversion('tourInquirySubmit');
};

/**
 * Fire an A/B test impression. Counts every visitor exposure so the
 * conversion-rate denominator is well-defined in GA4. Call once per page load.
 */
export const trackExperimentImpression = (experimentName, variant) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'experiment_impression', {
    experiment_name: experimentName,
    experiment_variant: variant,
  });
  // Dev-time signal — visible in the browser console + lets you confirm
  // which variant your sticky assignment landed on without opening GA4.
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(
      `%c[A/B ${experimentName}] variant: ${variant}`,
      'color:#fbbf24;font-weight:bold;background:#0a1f12;padding:2px 6px;border-radius:4px'
    );
  }
};

/**
 * Track tour detail view
 */
export const trackTourView = (tourName) => {
  ReactGA.event({
    category: 'Tour',
    action: 'view_tour',
    label: tourName,
  });
};
